import { z } from 'zod'

import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'

const errorSchema = z
  .array(
    z.object({
      message: z.string(),
      reason: z.string(),
      subject: z.string().optional(),
      subjectType: z.string().optional(),
      type: z.string(),
    })
  )
  .readonly()

const dataSchema = z.object({
  data: z.unknown().readonly(),
})

type ConverterInput<TData> = (
  | {
      data: TData
      error?: undefined
    }
  | {
      data: undefined
      error?: unknown
    }
) & {
  response: Response
}

export const defaultDataConverter = <TData>(data: ConverterInput<TData>): TData => {
  if ('error' in data && data.error) {
    const parsedError = errorSchema.safeParse(data.error)
    if (!parsedError.success) {
      throw new Error(`Error parsing API error: ${parsedError.error.message}`)
    }
    throw new Error(`API Error: ${JSON.stringify(data.error)}`)
  }

  return dataSchema.catch(defaultZodCatch).parse(data).data as TData
}
